import { Store } from 'vuex';
import { ILoginQuery } from '@/shared/model/login-query.model';
import { RP_COMPONENT_PREFIXES } from '@/shared/constants';

export default class ConfigurationService {
  constructor(store: Store<{}>) {
    this.store = store;
  }

  public findComponentNameByLoginQuery(nameArray: string[]): string {
    // alert(JSON.stringify(this.store.getters.loginQuery))
    // identify relying party
    let clientId = 'default';
    const loginQuery: ILoginQuery = this.store.getters.loginQuery;
    if (loginQuery != null) {
      clientId = loginQuery.client_id;
    }

    // lookup component prefix
    let prefix = null;
    let prefixDefault = null;
    for (let i = 0; i < RP_COMPONENT_PREFIXES.length; i++) {
      if (RP_COMPONENT_PREFIXES[i].name === clientId) {
        prefix = RP_COMPONENT_PREFIXES[i].prefix;
      }
      if (RP_COMPONENT_PREFIXES[i].name === 'default') {
        prefixDefault = RP_COMPONENT_PREFIXES[i].prefix;
      }
    }

    // lookup component name
    let componentName = null;
    for (let i = 0; i < nameArray.length; i++) {
      if (nameArray[i].startsWith(prefix + '-')) {
        componentName = nameArray[i];
        break;
      }
    }

    // lookup default component name
    if (componentName == null) {
      for (let i = 0; i < nameArray.length; i++) {
        if (nameArray[i].startsWith(prefixDefault + '-')) {
          componentName = nameArray[i];
          break;
        }
      }
    }

    //  alert(componentName);

    return componentName;
  }

  private store: Store<{}>;
}
